    import { Injectable } from '@angular/core';
    import { Router } from '@angular/router';
    import { map } from 'rxjs/operators';
    import { JwtHelperService } from '@auth0/angular-jwt';
    import { environment } from '../environments/environment';
    import { HttpClient } from '@angular/common/http';
    import { Observable, Subject } from 'rxjs';
    import { PartnerBasicInfo } from '../models/partner';
import { User } from '../models/user';
import { clearReportDeckCache } from '../components/end-client-reporting/report-deck-cache.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  baseUrl = environment.apiEndpoint + '/auth/';
  tokenName = 'TOKEN_' + environment.apiEndpoint;
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  private instanceChangedSource = new Subject<string>();
  instanceChanged$ = this.instanceChangedSource.asObservable();

  constructor(private http: HttpClient, private router: Router) {}

      loginAdmin(model: any) {
        return this.http.post(this.baseUrl + 'login', model).pipe(
          map((response: any) => {
            const user = response;
            if (user && user.token != null) {
              this.decodedToken = this.jwtHelper.decodeToken(user.token);
              if (user?.user?.roles.includes('Admin') || user?.user?.roles.includes('SuperAdmin')) {
                localStorage.setItem('user', JSON.stringify(user.user));
                localStorage.setItem(this.tokenName, user.token);
                localStorage.setItem('instanceId', user.user.instanceId);
              }
            }
            return response;
          })
        );
      }

      login(model: any) {
        return this.http.post(this.baseUrl + 'login', model).pipe(
          map((response: any) => {
            const user = response;
            if (user && user.token != null) {
                localStorage.setItem(this.tokenName, user.token);
                this.decodedToken = this.jwtHelper.decodeToken(user.token);
                localStorage.setItem('user', JSON.stringify(user.user));
            }
            return response;
          })
        );
      }

      guestLogin(token: string) {
        return this.http.post(this.baseUrl + 'guestlogin/' + token, {}).pipe(
          map((response: any) => {
            const user = response;
            if (user && user.token != null) {
                localStorage.setItem(this.tokenName, user.token);
                this.decodedToken = this.jwtHelper.decodeToken(user.token);
                localStorage.setItem('user', JSON.stringify(user.user));
            }
            return response;
          })
        );
      }

      impersonate(email: string, instance: string) {
        return this.http.get(this.baseUrl + 'impersonate?email=' + encodeURIComponent(email) + '&instance='+instance).pipe(
          map((response: any) => {
            const user = response;
            if (user) {
              localStorage.setItem(this.tokenName, user.token);
              this.decodedToken = this.jwtHelper.decodeToken(user.token);
              localStorage.setItem('user', JSON.stringify(user.user));
            }
          })
        );
      }
      // The signed-in person's accounts under the same email, across portals and instances
      getAccounts(): Observable<User[]> {
        return this.http.get<User[]>(this.baseUrl + 'accounts');
      }

      switchAccount(userId: string): Observable<void> {
        const body = { userId, tzOffset: new Date().getTimezoneOffset() };
        return this.http.post<{ token: string; user: User }>(this.baseUrl + 'switch-account', body).pipe(
          map(response => {
            // Cached sections and instance belong to the old account; drop them as logOut does
            localStorage.removeItem('comments');
            localStorage.removeItem('instanceId');
            localStorage.removeItem('sections');
            localStorage.removeItem('sectionsLinks');
            localStorage.setItem(this.tokenName, response.token);
            this.decodedToken = this.jwtHelper.decodeToken(response.token);
            localStorage.setItem('user', JSON.stringify(response.user));
          })
        );
      }

      supportLogon(path) {
        return this.http.get(this.baseUrl +'sso/initiated?path='+path);
      }

      forgot(model: any) {
        return this.http.post(this.baseUrl + 'ForgotPassword', model);
      }

      changePassword(model: any) {
        return this.http.post(this.baseUrl + 'ChangePassword', model);
      }

      reset(model: any) {
        return this.http.post(this.baseUrl + 'ResetPassword', model);
      }
      confirmEmailToken(model: any) {
        return this.http.post(this.baseUrl + 'ConfirmEmailToken', model);
      }

      loggedIn() {
        const token = this.getToken();
        if (this.jwtHelper.isTokenExpired(token)) {
          return false;
        }
      
        return true;
      }
      getToken() {
        return localStorage.getItem(this.tokenName);
      }
      autoLogIn(token) {
        var autoToken = this.jwtHelper.decodeToken(token);
        if(autoToken.role.includes('Admin') || autoToken.role.includes('SuperAdmin'))
        {
          localStorage.setItem(this.tokenName, token);
          return this.http.get(this.baseUrl + 'me').pipe(
            map((user: any) => {
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('instanceId', user.instanceId);
            })
          );
        }
        return null;

      }

      isInternal() {
        if (this.getUser().roles.includes('Admin') || this.getUser().roles.includes('Member')) {
          return true;
        }
        else return false;
      }

      isClient() {
        if (this.getUser().roles.includes('Client')) {
          return true;
        }
        else return false;
      }

      isAdmin() {
        if (this.getUser().roles.includes('Admin')) {
          return true;
        }
        else return false;
      }

      isGuest() {
        if (this.getUser().roles.includes('Guest')) {
          return true;
        }
      }

      // OpinionRoute instances across environments: the OR home instance per environment
      // plus the demo / sandbox instances that config sync writes into.
      private orInstanceIds = [
        'aaade042-c139-4285-33fb-08d76ad2902a', // OR (dev / staging, pre-existing)
        '339eb389-c219-4e1d-9378-08d7ae29a187', // OR (live)
        'b2880d39-10c3-4d87-f7ef-08d8280f4169', // demo (live)
        'da5e721b-60e3-4f2b-bc3e-c062d150c246', // playground (dev)
        '1df98762-3637-4609-a258-46bfb463db39', // demo (dev)
        'c7c64d59-5301-4dee-ba18-2c9ecfe419fb', // sandbox (staging)
        'a7ee55ea-3c82-4e47-a2b1-ee0fdd78aed6', // playground (live)
      ];

      // True when the logged-in user's instance is an OpinionRoute instance.
      isORInstance() {
        return this.isORInstanceId(this.getUser().instanceId);
      }

      // True when the given instance id is an OpinionRoute instance. Used where the
      // relevant instance is selected (e.g. admin) rather than the logged-in user's.
      isORInstanceId(instanceId: string | null | undefined) {
        return this.orInstanceIds.includes(instanceId?.toLowerCase() ?? '');
      }
      isSuperAdmin() {
        if (this.getUser().superAdmin) {
          return true;
        }
        else return false;
      }
      // MST is a per-instance user-defined role. Membership grants edit rights on Advanced Permissions.
      isMst(): boolean {
        return this.getUser()?.userDefinedRoles?.includes('MST') ?? false;
      }
      // Advanced Permissions (vendor portal) are editable only by Super Admins or the MST group.
      canEditVendorPermissions(): boolean {
        return this.isSuperAdmin() || this.isMst();
      }
      // Dev is a per-instance user-defined role for the programming team. Membership grants
      // access to the developer-only surfaces (e.g. the SP Flow build diagnostics and retry
      // actions on the questionnaire reviewer). Matched case-insensitively — the role is
      // named per instance, so 'Dev' and 'dev' both count.
      isDev(): boolean {
        return this.getUser()?.userDefinedRoles?.some(r => r?.toLowerCase() === 'developer' || r?.toLowerCase() === 'dev') ?? false;
      }
      isAbleToImpersonate() {
        if (this.getUser().ableToImpersonate) {
          return true;
        }
        else return false;
      }
      isVendorAdmin() {
        if (this.getUser().roles.includes('VendorAdmin')) {
          return true;
        }
        else return false;
      }
      isVendor() {
        if (this.getUser().roles.includes('Vendor')) {
          return true;
        }
        else return false;
      }
      setUser(user: User) {
        localStorage.setItem('user', JSON.stringify(user));
      }

      getUser(): User {
        return JSON.parse(localStorage.getItem('user'));
      }

      getUserLastLogin(): Date {
        const user = this.getUser();
        if (user && user.lastLogin) {
          return new Date(user.lastLogin);
        }
        return null;
      }

      // Only used on Admin Project
      getInstance() {
        const stored = localStorage.getItem('instanceId');
        if (stored && stored !== 'undefined' && stored !== 'null') {
          return stored;
        }
        // Fallback: pull the instanceId off the stored user object
        return this.getUser()?.instanceId ?? stored;
      }

      getSyntheticPanel() {
        var idsAsString = localStorage.getItem('syntheticPanel');
        if (idsAsString != null) {
          var parsedPanels: Array<PartnerBasicInfo> = JSON.parse(idsAsString);
          if (parsedPanels.length > 0) {
            return parsedPanels[0];
          }
        }
        
        return null;
      }

      setSyntheticPanels(syntheticPanels: Array<PartnerBasicInfo>) {
        if (syntheticPanels == null) return;
        localStorage.setItem('syntheticPanel', JSON.stringify(syntheticPanels));
      }

      // Only used on Admin Project
      saveInstance(instance: any) {
        localStorage.setItem('instanceId', instance);
        this.instanceChangedSource.next(instance);
      }

      logOut() {
        localStorage.removeItem(this.tokenName);
        localStorage.removeItem('user');
        localStorage.removeItem('comments');
        localStorage.removeItem('instanceId');
        localStorage.removeItem('sections');
        localStorage.removeItem('sectionsLinks');
        // Report data cached for the report list's thumbnails is the user's, not the browser's.
        clearReportDeckCache();
        location.reload();
        return false;
      }

      roleMatch(allowedRoles): boolean {
        let isMatch = false;
        let token = localStorage.getItem(this.tokenName);
        if (token == null) return false;

        let decodedToken =  this.jwtHelper.decodeToken(token);
        if (decodedToken == null) return false;

        const userRoles = decodedToken.role as Array<string>;
        allowedRoles.forEach(element => {
          if (userRoles.includes(element)) {
            isMatch = true;
            return;
          }
        });
        return isMatch;
      }

      //Access permissions
      ApplyAccess(type: string, id: string, userIds: string[]) {
        const url = `${this.baseUrl}access/${encodeURIComponent(type)}/${id}`;
        return this.http.post<void>(url, userIds);
      }
      GetAccess(id: string){
        const url = `${this.baseUrl}access/${id}`;
        return this.http.get<User[]>(url);
      }
    }
